import {Injectable} from "@angular/core";
import {RouterReducerState, RouterStateSerializer} from '@ngrx/router-store';
import {Params, RouterStateSnapshot} from "@angular/router";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {AppState} from "@store/reducers/index";

export interface RouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
}

export interface RouterState extends RouterReducerState<RouterStateUrl> {}

export const getRouterState = createFeatureSelector<
RouterReducerState<RouterStateUrl>
>('routerReducer');

@Injectable()
export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    // Only return an object including the URL, params and query params
    // instead of the entire snapshot
    return { url, params, queryParams };
  }
}

export const selectRouterState = (state: AppState) => state.router;
export const selectRouterUrl = createSelector(
  selectRouterState,
  (state: RouterState) => state.state.url
);



// WEBPACK FOOTER //
// ./src/app/store/reducers/router.reducer.ts